export const OFFER_COMPENSATION_URL = '/offers';

export type OfferCompensationDetails = {
  id?: StringOrNumber;
  sensitiveDataId?: StringOrNumber;
  createdAt?: string;
  updatedAt?: string;
  baseAmountType?: string;
  currency?: string;
  grossAmount?: string;
  grossProbationAmount?: string;
  calculatedGrossAmount?: string;
  probationReduction?: string;
  officeId?: StringOrNumber;
  contractType?: string;
  isAccepted?: boolean;
};
